import { render, staticRenderFns } from "./trash.vue?vue&type=template&id=8ec4309a&scoped=true&"
import script from "./trash.vue?vue&type=script&lang=js&"
export * from "./trash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec4309a",
  null
  
)

export default component.exports